// Helpers de sessão compartilhados entre o axios (services/api.js) e os
// serviços que ainda usam fetch puro (campeonatosService, tabelasPesoService).
export const getToken = () => sessionStorage.getItem('token');
export const setToken = (token) => sessionStorage.setItem('token', token);

export const authHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Sessão desliza: o backend renova o token a cada requisição autenticada e
// devolve o novo no header X-Refreshed-Token. Todo lugar que faz requisição
// autenticada precisa capturar isso, senão a sessão expira em 6h mesmo com
// uso ativo. `headers` aceita tanto o objeto do axios (chaves minúsculas)
// quanto um Headers do fetch (método .get).
export const captureRefreshedToken = (headers) => {
  const novoToken = typeof headers?.get === 'function'
    ? headers.get('x-refreshed-token')
    : headers?.['x-refreshed-token'];
  if (novoToken) setToken(novoToken);
};

export const handleUnauthorized = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userLoggedIn');
  sessionStorage.removeItem('userEmail');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};
